/**
 * Created by Ivan on 03.10.2025
 */

const ExtraBarIconAnimations = {};

ExtraBarIconAnimations.addRowAnimation = function () {
    return new cc.Sequence(
        new cc.FadeOut(0),
        new cc.FadeIn(0.1)
    ).setFinalize(() => {
        this.setOpacity(255);
    });
};

ExtraBarIconAnimations.removeRowAnimation = function () {
    return new cc.FadeOut(0.1);
};

ExtraBarIconAnimations.moveRowAnimation = function (position) {
    return new cc.MoveTo(0.2, position);
};
